import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-permit-created',
    templateUrl: './permit-created.component.html',
    styleUrls: ['./permit-created.component.scss'],
})
export class PermitCreatedComponent {
    @Input() categoryName = '';

    @Input() typeName = '';

    @Input() typeSubtitle = '';

    @Input() permitId = '';

    @Output() close = new EventEmitter<void>();

    onClose(): void {
        this.close.emit();
    }
}
